<!--
 * @FileDescription: 设备管理=》历史数据弹窗
 -->
<template>
  <div class="historical">
    <!-- 日期查询表单 -->
    <el-form :inline="true" :model="infoLine" class="demo-form-inline">
      <div
        class="nullList"
        v-if="
          activeName === 'signalIntensity' ||
            activeName === 'pressureChart' ||
            activeName === 'quantityElect' ||
            activeName === 'heightChart'
        "
      ></div>
      <div class="view-list" v-else>
        <div class="checkInfo">视图：</div>
        <div class="dateList">
          <span
            :class="setYearClass"
            @click="getYear('year')"
            v-if="activeName === 'heartRate' || activeName === 'bloodOxygen' || activeName === 'temperature'"
            >年</span
          >
          <span :class="setMonthClass" @click="getYear('month')">月</span>
          <span :class="setWeekClass" @click="getYear('week')">周</span>
          <span :class="setDayClass" @click="getYear('day')">日</span>
        </div>
      </div>
      <el-form-item label="时间：" class="data-pick">
        <el-date-picker
          v-if="dateType === 1"
          v-model="infoLine.searchTimeB"
          placeholder="日期"
          :picker-options="{ firstDayOfWeek: 7 }"
          :type="pickerDate"
          value-format="yyyy/MM/dd HH:mm:ss"
          :clearable="true"
          @change="selectDate"
        >
        </el-date-picker>
        <el-date-picker
          v-else
          v-model="infoLine.searchTimeB"
          placeholder="选择日期"
          :type="pickerDate"
          value-format="yyyy/MM/dd HH:mm:ss"
          :clearable="true"
          @change="selectDate"
        >
        </el-date-picker>
        <span class="dateTip" v-if="dateType === 1">查询该日期的当周数据</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="serachBtn" @click="searchChart">查询</el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in rowTabIds" :key="index" :label="item.label" :name="item.id">
              <div :id="item.id" :style="{ width: '100%', height: '350px' }"></div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rowData: {
      type: Object,
    },
  },
  data() {
    return {
      infoLine: {
        searchTimeB: '',
        searchTimeE: '',
      },
      activeName: 'heartRate',
      linecolor: 'rgba(255, 0, 72, 1)',
      lineBg: 'rgba(255, 0, 64, 0.3)',
      deviceNameId: '',
      dataChart: [],
      yAxisMax: 100,
      yAxisMin: 0,
      interval: 5,
      timeArr: [],
      setYearClass: '',
      setMonthClass: '',
      setWeekClass: '',
      setDayClass: 'yearDate',
      // X轴数据
      Xdate: [],
      // 0: 日，1：周，2：月，3：年
      dateType: 0,
      // 柱状图的数据1
      barDateOne: [],
      // 柱状图的数据2
      barDateTwo: [],
      barXdate: [],
      // 查询日期的 type 格式
      pickerDate: 'date',
      barBorderColor: 'rgba(255, 0, 64,0.4)',
      hoverBarColor: 'rgba(255, 0, 64,1)',
      hours: [],
      lastTime: '',
      theme: localStorage.getItem('theme'),
      axisLineColor: '',
      // 坐标轴文字颜色
      axisLabel: '',
      // 折线图的渐变颜色
      areaStyleColor: '',
      unit: '',
      unitName: '次/分钟',
      // 周查询时，获得的星期一日期
      newDataBegin: '',
      rowTabIds: [
        // tab 循环的数据 { id: 'temperature', label: '体温' },
        { id: 'heartRate', label: '心率' },
        { id: 'bloodOxygen', label: '血氧' },
        { id: 'signalIntensity', label: '信号强度' },
        { id: 'heightChart', label: '高度变化' },
        { id: 'pressureChart', label: '气压' },
        { id: 'quantityElect', label: '电量' },
        { id: 'dormancyState', label: '休眠次数' },
        { id: 'cappedState', label: '脱帽次数' },
        { id: 'stateCharge', label: '充电次数' },
      ],
      XMonthdate: {
        month: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        week: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      },
    }
  },
  methods: {
    // 打开图表，默认为' 日'
    handleReset() {
      this.setYearClass = ''
      this.setMonthClass = ''
      this.setWeekClass = ''
      this.setDayClass = 'yearDate'
      this.dateType = 0
      this.pickerDate = 'date'
      for (let i = 0; i < 24; i++) {
        this.hours.push(i + ':00')
      }
      this.Xdate = this.hours
      this.activeName = 'heartRate'
      let date = new Date()
      this.getBeginE(date)
    },
    // 选择日期时触发
    selectDate(e) {
      if (e === null) {
        this.infoLine.searchTimeB = ''
        this.infoLine.searchTimeE = ''
      } else {
        if (this.dateType === 0) {
          this.infoLine.searchTimeB = e
          this.getBeginE(new Date(this.infoLine.searchTimeB))
        } else if (this.dateType === 1) {
          let weekDayOne = getWeek(this.infoLine.searchTimeB)
          this.getBeginE(new Date(weekDayOne))
        } else {
          this.infoLine.searchTimeB = e
          this.infoLine.searchTimeE = ''
        }
      }
    },
    // 点击年/月/周/日切换
    getYear(type) {
      if (this.infoLine.searchTimeB === '' || this.infoLine.searchTimeB === null) {
        this.$message({ type: 'error', message: '请选择日期' })
        errorCollection('设备管理', '历史数据查询', { status: 200, data: { state: -1, msg: '请选择日期!' } })
        return
      }
      let date = new Date()
      var yearB = this.infoLine.searchTimeB.split('/')[0]
      this.setYearClass = ''
      this.setMonthClass = ''
      this.setWeekClass = ''
      this.setDayClass = ''
      this.infoLine.searchTimeE = ''
      if (type === 'year') {
        this.setYearClass = 'yearDate'
        this.dateType = 3
        this.pickerDate = 'year'
        this.Xdate = this.XMonthdate.month
        this.infoLine.searchTimeB = yearB + '/1/1 00:00:00'
        this.searchChart()
      } else if (type === 'month') {
        this.setMonthClass = 'yearDate'
        this.dateType = 2
        this.pickerDate = 'month'
        this.getBeginE(date)
      } else if (type === 'week') {
        this.setWeekClass = 'yearDate'
        this.dateType = 1
        this.pickerDate = 'date'
        this.Xdate = this.XMonthdate.week
        let weekDayFirst = getWeek(this.infoLine.searchTimeB)
        this.getBeginE(new Date(weekDayFirst))
      } else if (type === 'day') {
        this.setDayClass = 'yearDate'
        this.dateType = 0
        this.pickerDate = 'date'
        this.Xdate = this.hours
        this.getBeginE(date)
      }
    },
    // 心率/血氧/体温echart柱状图
    barEchart() {
      this.$nextTick(() => {
        var myChart = this.$echarts.init(document.getElementById(this.activeName))
        myChart.clear()
        myChart.setOption({
          title: {},
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function(params) {
              let maxVal = params[0].value + params[1].value
              return params[0].name + '<br/>' + params[0].value + ' - ' + maxVal + ' ' + params[1].seriesName
            },
          },
          grid: {
            top: 10,
            left: 27,
            right: 5,
            bottom: 20,
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            data: this.Xdate,
            axisLine: {
              //y轴
              onZero: false,
              lineStyle: {
                color: this.axisLineColor,
              },
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            splitLine: {
              //网格线
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: this.axisLabel, //更改坐标轴文字颜色
              },
              show: true,
            },
          },
          yAxis: {
            type: 'value',
            min: this.yAxisMin,
            max: this.yAxisMax,
            interval: this.interval,
            position: 'right',
            splitLine: {
              show: true,
              lineStyle: {
                color: this.axisLineColor, // 网格线的颜色
              },
            },
            axisLine: {
              //y轴
              show: false,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: this.axisLabel, //更改坐标轴文字颜色
              },
              show: true,
            },
          },
          series: [
            {
              type: 'bar',
              barWidth: 10,
              stack: true, // 柱状图数据叠加，设置一样
              itemStyle: {
                barBorderColor: 'rgba(0,0,0,0)',
                color: 'rgba(0,0,0,0)',
                borderRadius: 5,
              },
              emphasis: {
                itemStyle: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)',
                },
              },
              data: this.barDateOne,
            },
            {
              type: 'bar',
              name: this.unitName,
              barWidth: 10,
              stack: true, // 柱状图数据叠加，设置一样
              itemStyle: {
                barBorderColor: this.barBorderColor,
                color: this.barBorderColor,
                barBorderRadius: 7,
              },
              emphasis: {
                //鼠标悬停时
                itemStyle: {
                  barBorderColor: this.hoverBarColor,
                  color: this.hoverBarColor,
                  barBorderRadius: 7,
                },
              },
              data: this.barDateTwo,
            },
          ],
        })
      })
    },
    // echart折线图
    viewData() {
      this.$nextTick(() => {
        var myChart = this.$echarts.init(document.getElementById(this.activeName))
        myChart.clear()
        myChart.setOption({
          title: {},
          tooltip: {
            trigger: 'axis',
            formatter: function(params) {
              let dataStr = `<div style="display:inline-block;width: 12px;height: 12px;background: #FF0040;border-radius: 50%"></div>`
              var param = params[0]
              return param.value[0] + '<br/>' + dataStr + ' ' + param.value[1] + ' ' + param.value[2]
            },
            axisPointer: {
              animation: false,
            },
          },
          toolbox: {
            // 区域放大/还原工具
            right: 65,
            itemSize: 25,
            top: -5,
            feature: {
              dataZoom: {
                yAxisIndex: 'none',
              },
              restore: {},
            },
          },
          xAxis: {
            type: 'time',
            boundaryGap: false,
            splitLine: {
              //网格线
              show: false,
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: this.axisLineColor,
              },
            },
            axisTick: {
              show: false, //y轴刻度线
            },
            axisLabel: {
              textStyle: {
                color: this.axisLabel, //更改坐标轴文字颜色
              },
              show: true,
            },
            min: this.infoLine.searchTimeB,
            max: this.lastTime,
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: this.axisLineColor, // 网格线的颜色
              },
            },
            min: this.yAxisMin,
            max: this.yAxisMax,
            interval: this.interval,
            position: 'right',
            axisLine: {
              show: false, //y轴
            },
            axisTick: {
              show: false, //y轴刻度线
            },
            axisLabel: {
              textStyle: {
                color: this.axisLabel, //更改坐标轴文字颜色
              },
              formatter: '{value}' + this.unit,
            },
          },
          dataZoom: [
            {
              // 鼠标滑动放大缩小
              type: 'inside',
              throttle: 50,
            },
          ],
          series: [
            {
              type: 'line',
              showSymbol: false,
              hoverAnimation: false,
              data: this.dataChart,
              smooth: true,
              areaStyle: {
                // 区域内颜色渐变
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: this.lineBg, // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: this.areaStyleColor, // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
              itemStyle: {
                normal: {
                  lineStyle: {
                    color: this.lineBg,
                  },
                },
              },
            },
          ],
          grid: {
            top: 10,
            left: 27,
            right: 25,
            bottom: 20,
            containLabel: true,
          },
        })
      })
    },
    // 获取心率+体温+血氧
    getHealthChart(type) {
      var fieldType = null
      if (type === undefined || type === 'heartRate') {
        // 判断 心率
        fieldType = 1
      } else if (type === 'bloodOxygen') {
        // 判断 血氧
        fieldType = 0
      } else {
        // 判断 体温
        fieldType = 2
      }
      let startTime = ''
      if (this.dateType === 1) {
        startTime = this.newDataBegin
      } else {
        startTime = this.infoLine.searchTimeB
      }
      this.deviceNameId = this.rowData !== '' ? this.rowData.serialNumber : this.deviceNameId
      let params = {
        deviceName: this.deviceNameId,
        startTime: startTime,
        limit: 2000,
        field: fieldType,
        endTime: this.infoLine.searchTimeE,
        type: this.dateType,
      }
      healthStatusRecord(params).then(res => {
        if (res.state === 0) {
          this.barDateOne = []
          this.barDateTwo = []
          this.handleData(type,res.data)
        }
      })
    },
    // 处理获取来的数据心率+体温+血氧
    handleData(type,dataList) {
      var maxData = []
      this.dataChart = []
      for (let item of dataList) {
        if (type === undefined || type === 'heartRate') {
          if (this.dateType === 0) {
            maxData.push(Number(item.heartRate))
            this.dataChart.push({
              value: [item.timestamp, Number(item.heartRate), '次/分钟'],
            })
          } else {
            this.barDateOne.push(Number(item.minHeart))
            this.barDateTwo.push(Number(item.maxHeart) - Number(item.minHeart))
            maxData.push(Number(item.maxHeart))
            this.barBorderColor = 'rgba(255, 0, 64,0.4)'
            this.hoverBarColor = 'rgba(255, 0, 64,1)'
          }
        } else if (type === 'bloodOxygen') {
          if (this.dateType === 0) {
            this.dataChart.push([item.timestamp, Number(item.bloodOxygen), '%'])
            maxData.push(Number(item.bloodOxygen))
          } else {
            this.barDateOne.push(Number(item.minBlood))
            this.barDateTwo.push(Number(item.maxBlood) - Number(item.minBlood))
            maxData.push(Number(item.maxBlood))
            this.barBorderColor = 'rgba(22, 220, 147,0.4)'
            this.hoverBarColor = 'rgba(22, 220, 147,1)'
          }
        } else if (type === 'temperature') {
          if (this.dateType === 0) {
            this.dataChart.push([item.timestamp, Number(item.bodyTemperature), '℃'])
            maxData.push(Number(item.bodyTemperature))
          } else {
            this.barDateOne.push(Number(item.minTem))
            this.barDateTwo.push(Number(item.maxTem) - Number(item.minTem))
            maxData.push(Number(item.maxTem))
            this.barBorderColor = 'rgba(14, 101, 221,0.4)'
            this.hoverBarColor = 'rgba(14, 101, 221,1)'
          }
        }
      }
      this.getAxisNum(type, maxData)
    },
    getAxisNum(type, maxData) {
      let MaxMin = getmaxMin(maxData)
      if (this.dateType === 0) {
        if (type === 'bloodOxygen') {
          this.yAxisMax = MaxMin.Maximum
          this.yAxisMin = MaxMin.Minimum - 2
        } else {
          this.yAxisMax = MaxMin.Maximum + 10
          this.yAxisMin = MaxMin.Minimum - 10
        }
        this.interval = this.yAxisMax - this.yAxisMin !== 0 ? (this.yAxisMax - this.yAxisMin) / 5 : 2
        this.viewData()
      } else {
        this.yAxisMax = MaxMin.Maximum + 10
        this.yAxisMin = MaxMin.Minimum - 10
        this.interval = this.yAxisMax - this.yAxisMin !== 0 ? (this.yAxisMax - this.yAxisMin) / 5 : 2
        this.barEchart()
      }
    },
    // 获取echart信号强度
    getBaseStationChart() {
      let params = {
        deviceName: this.deviceNameId,
        startTime: this.infoLine.searchTimeB,
        limit: 2000,
        endTime: this.infoLine.searchTimeE,
      }
      var baseData = []
      baseStationRecord(params).then(res => {
        if (res.state === 0) {
          this.dataChart = []
          for (let item of res.data) {
            baseData.push(Number(item.rss))
            this.dataChart.push([item.timestamp, Number(item.rss), 'db'])
          }
          this.yAxisMax = getmaxMin(baseData).Maximum + 10
          this.yAxisMin = getmaxMin(baseData).Minimum - 5
          this.interval = this.yAxisMax - this.yAxisMin !== 0 ? (this.yAxisMax - this.yAxisMin) / 5 : 5
        }
        this.viewData()
      })
    },
    // 获取休眠次数+戴帽次数+充电次数
    getDeviceStatusChart(type) {
      var statusType = null
      if (type === 'dormancyState') {
        statusType = 0
      } else if (type === 'cappedState') {
        statusType = 1
      } else {
        statusType = 2
      }
      let deviceTime = ''
      if (this.dateType === 1) {
        deviceTime = this.newDataBegin
      } else {
        deviceTime = this.infoLine.searchTimeB
      }
      let params = {
        deviceName: this.deviceNameId,
        startTime: deviceTime,
        limit: 100,
        endTime: this.infoLine.searchTimeE,
        type: this.dateType,
        field: statusType,
      }
      deviceStatusRecord(params).then(res => {
        if (res.state === 0) {
          this.dataChart = []
          for (let item of res.data) {
            if (type === 'dormancyState') {
              this.dataChart.push(Number(item.standByNumber))
            } else if (type === 'cappedState') {
              this.dataChart.push(Number(item.wearingNumber))
            } else if (type === 'stateCharge') {
              this.dataChart.push(Number(item.chargingNumber))
            }
          }
        }
        this.yEchartNum()
      })
    },
    // 根据最小最大定义Y轴
    yEchartNum() {
      let maxVal = getmaxMin(this.dataChart).Maximum
      this.yAxisMax = maxVal % 2 === 1 ? maxVal + 1 : maxVal + 2
      this.yAxisMin = getmaxMin(this.dataChart).Minimum
      this.interval = this.yAxisMax - this.yAxisMin !== 0 ? (this.yAxisMax - this.yAxisMin) / 2 : 1
      this.frequencyEchart()
    },
    // 获取echart气压/高度
    getHeightChart(type) {
      let params = {
        deviceName: this.deviceNameId,
        startTime: this.infoLine.searchTimeB,
        limit: 2000,
        endTime: this.infoLine.searchTimeE,
      }
      var heightData = []
      chartRecord(params).then(res => {
        if (res.state === 0) {
          this.dataChart = []
          for (let item of res.data) {
            if (type === 'pressureChart') {
              this.dataChart.push([item.timestamp, (Number(item.pressure) / 1000).toFixed(3), 'kPa'])
              heightData.push(Number(item.pressure) / 1000)
            } else if (type === 'heightChart') {
              this.dataChart.push([item.timestamp, Number(item.altitude).toFixed(3), 'm'])
              heightData.push(Number(item.altitude))
            }
          }
          this.yAxisMax = getmaxMin(heightData).Maximum + 10
          this.yAxisMin = getmaxMin(heightData).Minimum - 5
          this.interval = this.yAxisMax - this.yAxisMin !== 0 ? (this.yAxisMax - this.yAxisMin) / 5 : 10
        }
        this.viewData()
      })
    },
    // 获取echart电量
    getDeviceBatteryChart(type) {
      let params = {
        deviceName: this.deviceNameId,
        startTime: this.infoLine.searchTimeB,
        limit: 2000,
        endTime: this.infoLine.searchTimeE,
      }
      deviceStatusBattery(params).then(res => {
        if (res.state === 0) {
          this.dataChart = []
          for (let item of res.data) {
            // deviceData.push(Number(item.freeBattery))
            this.dataChart.push([item.timestamp, Number(item.freeBattery), '%'])
          }
        }
        this.yAxisMax = 100
        this.yAxisMin = 0
        this.interval = this.yAxisMax - this.yAxisMin !== 0 ? (this.yAxisMax - this.yAxisMin) / 10 : 5
        this.viewData()
      })
    },
    // 点击切换tab
    handleClick(tab, event) {
      if (this.infoLine.searchTimeB === '' || this.infoLine.searchTimeB === null) {
        let date = new Date()
        this.getBeginE(date)
      }
      this.activeName = tab.paneName
      this.getYear('day')
      if (tab.paneName === 'heartRate') {
        this.linecolor = 'rgba(255, 0, 72, 1)'
        this.lineBg = 'rgba(255, 0, 64, 0.3)'
        this.activeName = 'heartRate'
        this.unit = ''
        this.unitName = '次/分钟'
      } else if (tab.paneName === 'bloodOxygen') {
        this.linecolor = 'rgba(13, 218, 143, 1)'
        this.lineBg = 'rgba(0, 255, 162, 1)'
        this.activeName = 'bloodOxygen'
        this.unit = '%'
        this.unitName = '%'
      } else {
        this.linecolor = 'rgba(14, 101, 221, 1)'
        this.lineBg = 'rgba(14, 101, 221, 1)'
        this.getIdInfo(tab.paneName)
      }
    },
    // 切换tab后id的变化
    getIdInfo(type) {
      if (type) {
        switch (type) {
          case 'temperature':
            this.unit = '℃'
            this.unitName = '℃'
            break
          case 'signalIntensity':
            this.setDayClass = 'yearDate'
            this.unit = ''
            break
          case 'pressureChart':
            this.unit = ''
            this.setDayClass = 'yearDate'
            break
          case 'dormancyState':
            this.unit = ''
            break
        }
      }
    },
    // 点击查询根据类型去请求接口
    searchChart() {
      if (this.infoLine.searchTimeB === '' || this.infoLine.searchTimeB === null) {
        this.$message({ type: 'error', message: '请选择日期' })
        errorCollection('设备管理', '历史数据查询', { status: 200, data: { state: -1, msg: '请选择日期!' } })
      } else {
        if (
          this.activeName === 'heartRate' ||
          this.activeName === 'bloodOxygen' ||
          this.activeName === 'temperature'
        ) {
          this.getHealthChart(this.activeName)
        } else if (this.activeName === 'pressureChart' || this.activeName === 'heightChart') {
          this.getHeightChart(this.activeName)
        } else if (this.activeName === 'signalIntensity') {
          this.getBaseStationChart()
        } else if (this.activeName === 'quantityElect') {
          this.getDeviceBatteryChart()
        } else if (
          this.activeName === 'dormancyState' ||
          this.activeName === 'cappedState' ||
          this.activeName === 'stateCharge'
        ) {
          this.getDeviceStatusChart(this.activeName)
        }
      }
    },
    // 休眠次数+戴帽次数+充电次数 echart柱状图
    frequencyEchart() {
      this.$nextTick(() => {
        var myChart = this.$echarts.init(document.getElementById(this.activeName))
        myChart.clear()
        myChart.setOption({
          title: {},
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function(params) {
              var paramData = params[0]
              return paramData.axisValue + '<br/>' + paramData.value + ' 次'
            },
          },
          grid: {
            top: 10,
            left: 27,
            right: 5,
            bottom: 20,
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            data: this.Xdate,
            axisLine: {
              //y轴
              show: true,
              onZero: false,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            splitLine: {
              //网格线
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: this.axisLabel, //更改坐标轴文字颜色
              },
              show: true,
            },
          },
          yAxis: {
            type: 'value',
            min: this.yAxisMin,
            max: this.yAxisMax,
            interval: this.interval,
            position: 'right',
            axisLine: {
              show: false, //y轴
            },
            splitLine: {
              show: true,
              lineStyle: {
                // 网格线的颜色
                color: this.axisLineColor,
              },
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: this.axisLabel, //更改坐标轴文字颜色
              },
              show: true,
            },
          },
          series: [
            {
              type: 'bar',
              barWidth: 10,
              itemStyle: {
                barBorderColor: 'rgba(14, 101, 221,0.4)',
                color: 'rgba(14, 101, 221,0.4)',
                barBorderRadius: 7,
              },
              emphasis: {
                itemStyle: {
                  barBorderColor: 'rgba(14, 101, 221,1)',
                  color: 'rgba(14, 101, 221,1)',
                  barBorderRadius: 7,
                },
              },
              data: this.dataChart,
            },
          ],
        })
      })
    },
    // 获取转换后的日期
    getBeginE(date) {
      let getNow = getNowTime(date)
      var yearInMonth = getNow.formatDateB.split('/')[0]
      var monthInMonth = getNow.formatDateB.split('/')[1]
      this.lastTime = getNow.lastDate
      if (this.dateType === 1) {
        this.newDataBegin = getNow.formatDateB
        this.infoLine.searchTimeE = ''
      } else if (this.dateType === 2) {
        this.Xdate = getDaysInMonth(yearInMonth, monthInMonth)
        this.infoLine.searchTimeB = yearInMonth + '/' + monthInMonth + '/1 00:00:00'
      } else {
        this.infoLine.searchTimeB = getNow.formatDateB
        this.infoLine.searchTimeE = getNow.formatDate
      }
      this.searchChart()
    },
    changeChartColor() {
      if (this.theme === 'default') {
        this.axisLineColor = 'rgba(229, 229, 229, 1)'
        this.axisLabel = 'rgba(153, 153, 153, 1)'
        this.areaStyleColor = 'rgba(255, 255, 255, 1)'
      } else {
        this.axisLineColor = 'rgba(229, 229, 229,0.1)'
        this.axisLabel = 'rgba(255, 255, 255, 1)'
        this.areaStyleColor = 'rgba(10, 36, 112, 1)'
      }
    },
  },
  created() {
    this.changeChartColor()
  },
  mounted() {
    let date = new Date()
    this.getBeginE(date)
  },
  computed: {
    getTheme() {
      // 主题切换标识监听
      return this.$store.state.theme
    },
  },
  watch: {
    getTheme(val) {
      this.theme = val
      this.changeChartColor()
    },
    rowData: {
      immediate: true, // 这句重要
      handler(val) {
        this.handleReset()
      },
    },
  },
}
import { getNowTime, getmaxMin, getDaysInMonth, getWeek } from '@/api/common'
import {
  chartRecord,
  healthStatusRecord,
  baseStationRecord,
  deviceStatusRecord,
  deviceStatusBattery,
} from '@/api/helmetManage'
import { errorCollection } from '@/api/dmp/dmpCollection'
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.checkInfo
  display inline-block
  font-size 18px
  line-height 30px /* no */
  font-weight bold
  margin-right 15px
.nullList
  display inline-block
.view-list
  display inline-block
  .dateList
    width 130px /* no */
    display inline-block
    line-height 30px /* no */
    border-radius 4px
    margin-right 23px
    cursor pointer
    span
      display inline-block
      width 25%
      text-align center
      box-sizing border-box
    .yearDate
      border 1px solid #0E65DD
      border-radius 4px
      color #0E65DD
.data-pick
  position relative
  .dateTip
    position absolute
    bottom -25px /* no */
    left 0px
    font-size 12px
</style>
